import React from 'react';
import classnames from 'classnames';
import {Button} from 'comp/button';

export default class GoogleLoginButton extends React.Component {

  constructor(props) {
    super(props);
    this.signIn = this.signIn.bind(this);
  }

  signIn(ev) {
    if (ev) { ev.preventDefault(); }

    const auth2 = window.gapi.auth2.getAuthInstance();
    const { onSuccess } = this.props;
    const options = { prompt: 'consent' };

    auth2.signIn(options).then(res => onSuccess(res));
  }

  render() {
    const { text, ...props } = this.props;
    return (
      <Button
        clickAction={this.signIn}
        {...props}
      >
        <i
          className={classnames('fa', 'fa-google-plus')}
        />&nbsp;{text}
      </Button>
    );
  }
}

GoogleLoginButton.propTypes = {
  onSuccess: React.PropTypes.func.isRequired,
  text: React.PropTypes.string
};

GoogleLoginButton.defaultProps = {
  text: 'Sign In with Google'
};


// WEBPACK FOOTER //
// ./src/components/login/components/GoogleLoginButton.jsx